import apiFetch from '@wordpress/api-fetch';
import infoIcon from '../../svg/info.svg';

const activeClass = 'favorite-toggle--active';
const route       = '/ncasi/v1/favorites';
const selectors = {
	container: '#saved .card-grid__items',
	favorite: '.favorite',
	favToggle: '.favorite-toggle',
	activeClass: 'favorite-toggle--active',
	activeState: '.favorite-toggle--active',
	cardHeading: '.card__heading',
	horizontalClass: 'card--horizontal',
}

const favorite = async ( node ) => {
	const { objectId } = node.dataset;
	const { container, activeClass, favToggle, cardHeading, horizontalClass, favorite} = selectors;

	const identifier = `[data-object-id="${objectId}"]`;
	const from = node.closest('.card') ?? false;
	const to = document.querySelector(container) ?? false;

	console.log('saving');

	try {
		return await apiFetch({
			method: 'POST',
			path: route,
			data: {
				object_id: objectId,
				object_type: node.dataset.type ?? 'post',

			}
		}).then((data) => {

			if (!data.id) {
				return;
			}

			if (to && from) {
				const clone = from.cloneNode(true);
				clone.classList.add(horizontalClass, 'clone');
				clone.querySelector(cardHeading).classList.replace('has-h4-variant', 'has-h3-variant');
				clone.querySelector(favToggle).classList.add(activeClass);
				clone.insertAdjacentElement( 'beforeend', clone.querySelector(favorite) );
				to.insertAdjacentElement( 'beforeend', clone );
			}

			document.querySelectorAll(identifier).forEach((button) => {
				button.classList.add(activeClass);
				button.setAttribute('data-id', data.id);
				setTooltip(button, 'Saved');
			});

		});
	} catch (err) {
		console.error(err);
	}
}


const unfavorite = async ( node ) => {
	const { id } = node.dataset;
	const { activeClass, container } = selectors;

	const identifier = `[data-id="${id}"]`;
	const to = document.querySelector(container) ?? false;

	try {
		return await apiFetch({
			method: 'DELETE',
			path: `${route}/${id}`
		}).then((data) => {
			if (!data || !data.deleted) {
				return;
			}

			if (to) {
				// remove selected elements from Saved container.
				const exists = to.querySelectorAll(identifier);
				exists.forEach((el) => {
					to.removeChild(el.closest('.card'));
				});
			}

			// remove active class in other locations.
			document.querySelectorAll(identifier).forEach((button) => {
				button.classList.remove(activeClass);
				button.removeAttribute('data-id');
				setTooltip(button, 'Save Event');
			});
		});
	} catch (err) {
		console.error(err);
	}
}

const setTooltip = ( node, text, selector = '.tooltip__content .text' ) => {
	const tooltip = node.querySelector( selector );

	if ( !tooltip ) {
		return;
	}
	while ( tooltip.firstChild ) {
		tooltip.removeChild( tooltip.firstChild );
	}

	tooltip.appendChild( document.createTextNode( text ) );
}

const toggle = (node) => node.classList.contains( activeClass ) && node.dataset.id ?  unfavorite( node ) : favorite( node );

export function init() {

	document.addEventListener('click', function(e) {
		let target = e.target;

		while ( target && target.parentNode ) {

			if ( target.classList.contains( 'favorite-toggle' ) ) {
				toggle( target );
				return;
			}

			target = target.parentNode;
		}
	});
}
